import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";
import FormControl from "@mui/material/FormControl";
import FormHelperText from "@mui/material/FormHelperText";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import { getIn, useField, useFormikContext } from "formik";
import { useEffect } from "react";
import { buildArtFieldLabel } from "./artFieldLabelUtils";
import { useArtFieldMetadata } from "./artFieldMetadataContext";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};

const FormikSelectMultiple = ({ children, getOptionLabel, ...props }) => {
    const [field, meta] = useField(props);
    const { values, setFieldValue } = useFormikContext();
    const fieldValue = getIn(values, props.name);
    const fieldMetadata = useArtFieldMetadata(props.name);
    const label = buildArtFieldLabel(props.label, fieldMetadata);

    useEffect(() => {
        if (props.callBack) {
            props.callBack(fieldValue);
        }
    }, [fieldValue, props]);

    const onChange = (event) => {
        const value = event.target.value;
        setFieldValue(props.name, typeof value === 'string' ? value.split(',') : value);
        if (props.callBack) {
            props.callBack(value);
        }
    };

    const getLabel = (value) => {
        if (getOptionLabel) {
            return getOptionLabel(value);
        }
        const option = children?.find((child) => child?.props?.value === value);
        return option?.props?.children || value;
    };

    return (
        <FormControl
            sx={props.sx ? { width: "100%", ...props.sx } : { width: "100%" }}
            error={meta.touched && meta.error ? true : false}
            disabled={props.disabled}
            variant={props.variant || "standard"}>
            <InputLabel>{label}</InputLabel>
            <Select
                multiple
                onChange={onChange}
                name={field.name}
                value={fieldValue || []}
                variant={props.variant}
                label={label}
                MenuProps={MenuProps}
                renderValue={(selected) => (
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                        {selected.map((value) => (
                            <Chip key={value} label={getLabel(value)} size="small" />
                        ))}
                    </Box>
                )}>
                {children}
            </Select>
            <FormHelperText>
                {meta.touched && meta.error ? meta.error : null}
            </FormHelperText>
        </FormControl>
    );
};

export default FormikSelectMultiple;
